// @ts-nocheck
/* eslint-disable */
export default class Loader {
	constructor(parentCont) {
		this._parentCont = parentCont;

		this._lid = Mapy.CML.addListener(loading => {
			let loader = Mapy.getComponent("loader").getBigCon();

			if (loading) {
				Mapy.getComponent("loader").start(true, true);
				if (Mapy.getComponent("route").isActive()) {
					this._parentCont.appendChild(loader);
					loader.style.paddingTop = 0;
					loader.style.paddingBottom = 0;
				}
			}
			else{
				Mapy.getComponent("loader").end(true);
				loader.remove();
			}
		}, "route.loading");
	}

	destroy() {
		Mapy.CML.removeListenerId(this._lid);
		this._container.remove();
	}
}
